var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.filteredTodos),function(todo,index){return _c('li',{key:index},[_vm._t("todo",function(){return [_vm._v(" "+_vm._s(todo.text)+" ")]},{"todo":todo})],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }